import { NgModule } from '@angular/core';
import { MenuForDirective } from './menu-for.directive';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuComponent } from './menu.component';
import { CommonModule } from '@angular/common';
import { LunaCommonModule } from '../../common.module';

@NgModule({
    declarations: [
        MenuComponent,
        MenuForDirective,
        MenuItemComponent
    ],
  imports: [
      CommonModule,
      LunaCommonModule 
    ],
    exports: [
        MenuComponent,
        MenuForDirective,
        MenuItemComponent
    ],
    providers: [],
    bootstrap: []
})
export class RICSMenuModule { }
